import { Info } from '../../../icons';

export const InfoIcon = Info;
InfoIcon.displayName = 'InfoIcon';
